import { createSlice } from '@reduxjs/toolkit'

export const nodesSlice = createSlice({
    name: 'nodeList',
    initialState: {
        gid: -1,
        loaded: false,

        busy: false,
        items: {},

    },
    reducers: {
        loadNodeList: (state,{payload}) => {
            state.gid = payload.gid
            state.loaded = false

            Object.entries(state.items).forEach(([id,node])=> {
                node.loaded = false
            })
        },

        loadedNodeList: (state, {payload})=>{
            let busy = false
            Object.entries(payload).forEach(([id,node])=>{

                // add node if not existing
                if (!(node.nid in state.items)){
                    state.items[node.nid] = {
                        gid: node.gid,
                        nid: node.nid,
                        loaded: false,
                        config: {},
                    }
                }

                const state_node = state.items[node.nid]
                //
                state_node.gid = node.gid
                state_node.nid = node.nid
                state_node.mac = node.mac

                state_node.settings_applied = node.settings_applied

                state_node.enabled = !!node.enabled
                state_node.connected = !!node.connected
                state_node.present = !!node.present

                state_node.config.power_saver = {
                    on_time_sec: node.config.power_saver === undefined || node.config.power_saver.on_time_sec === undefined ? 0 : node.config.power_saver.on_time_sec,
                    cron_value: node.config.power_saver === undefined || node.config.power_saver.cron_value === undefined || node.config.power_saver.cron_value === ''? '30 6 * * *' : node.config.power_saver.cron_value,
                }

                state_node.last_contact = node.last_contact

                state_node.loaded = true

                if (node.settings_applied === 0){
                    busy = true
                }
            })

            const deleteIds = []
            Object.entries(state.items).forEach(([id,node])=> {
                if (!node.loaded){
                    deleteIds.push(id)
                }
            })

            Object.entries(deleteIds).forEach(([k, id])=> {
                delete state.items[id]
            })

            state.busy = busy
            state.loaded = true
        },

        updateNodeListProp: (state, {payload}) => {
        },

        updateNodeListPropDone: (state, {payload}) => {
        },

        updateNodeListConfig: (state, {payload}) => {
        },

        updateNodeListConfigDone: (state, {payload}) => {
        },

        deleteNodeFromNodeList: (state, {payload}) => {
        },

        deleteNodeFromNodeListDone: (state, {payload}) => {
        },

    }
})

export const {
    loadNodeList, loadedNodeList,
    updateNodeListProp, updateNodeListPropDone,
    updateNodeListConfig, updateNodeListConfigDone,
    deleteNodeFromNodeList, deleteNodeFromNodeListDone,


} = nodesSlice.actions

export default nodesSlice.reducer
